import { createSlice } from "@reduxjs/toolkit";

const initialMasterDataUserState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  masterDataForEdit: undefined,
  lastError: null
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const superAdminMasterDataUserSlice = createSlice({
  name: "masterDataUser",
  initialState: initialMasterDataUserState,
  reducers: {
    catchError: (state, action) => {
      state.listLoading = false;
      state.actionsLoading = false;
      // state.error = `${action.type}: ${action.payload.error}`;
      // if (action.payload.callType === callTypes.list) {
      //   state.listLoading = false;
      // } else {
      //   state.actionsLoading = false;
      // }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    // getalluserdata
    masterDataUsersFetched: (state, action) => {
      const { count, rows, message, status } = action.payload;
      state.actionsLoading = false;
      state.listLoading = false;
      state.error = null;
      state.entities = rows;
      state.totalCount = count;
    },

    // getuserdata
    masterDataUserFetched: (state, action) => {
      const user = action.payload;
      state.actionsLoading = false;
      state.listLoading = false;
      state.error = null;
      state.masterDataForEdit = user;
    },

    reloadData: (state, action) => {
      state.actionsLoading = false;
      state.listLoading = false;
      state.error = null;
      state.masterDataForEdit = undefined;
    }
  }
});
